export const rbaSitzung13Juni2026Bericht = {
  "id": "rba-sitzung-13-juni-2026-bericht",
  "title": "RBA Sitzung vom 13. Juni 2026: Gemeinsam die Rugby Bundesliga weiterentwickeln",
  "slug": "rba-sitzung-13-juni-2026-bericht",
  "publishedAt": "2026-06-16T09:00:00Z",
  "author": "Rugby Bundesliga Redaktion",
  "language": "de",
  "readTime": "7 min",
  "tags": [
    "Rugby",
    "Bundesliga",
    "RBA",
    "Saison 2025/26",
    "Hannover",
    "Streaming",
    "RC Luxemburg"
  ],
  "excerpt": "Die Sitzung des Rugby Bundesliga Ausschusses am 13. Juni 2026 in Hannover war ein weiterer wichtiger Meilenstein für die Entwicklung des Bundesligarugbys in Deutschland. Mit hervorragender Beteiligung der Vereine, konstruktiven Diskussionen und zahlreichen richtungsweisenden Beschlüssen.",
  "img": "/images/rba-sitzung-13-juni-2026-bericht.jpeg",
  "blocks": [
    {
      "type": "paragraph",
      "content": "Die Sitzung des Rugby Bundesliga Ausschusses am 13. Juni 2026 in Hannover war ein weiterer wichtiger Meilenstein für die Entwicklung des Bundesligarugbys in Deutschland. Mit einer hervorragenden Beteiligung der Vereine, konstruktiven Diskussionen und zahlreichen richtungsweisenden Beschlüssen zeigte sich einmal mehr, wie stark die Zusammenarbeit innerhalb der Bundesliga inzwischen geworden ist."
    },
    {
      "type": "paragraph",
      "content": "Besonders bemerkenswert war die Atmosphäre der Sitzung. Unterschiedliche Positionen wurden offen und respektvoll diskutiert, stets mit dem gemeinsamen Ziel, den Spielbetrieb weiterzuentwickeln und die Bundesliga langfristig zu stärken. Das Vertrauen zwischen den Vereinen wächst von Sitzung zu Sitzung. Es wächst zusammen, was lange schon zusammengehörte."
    },
    {
      "type": "paragraph",
      "content": "Neben den organisatorischen Punkten standen zahlreiche Anträge auf der Tagesordnung, die intensiv beraten und beschlossen wurden."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Kontinuität in der Spielbetriebsorganisation"
    },
    {
      "type": "paragraph",
      "content": "Die Staffelleiter der 2. Bundesliga Nord/Ost und Süd/West wurden einstimmig in ihren Ämtern bestätigt. Damit setzen die Vereine auf bewährte Strukturen und Kontinuität in der Organisation des Spielbetriebs."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Streamingpflicht in der 1. Bundesliga"
    },
    {
      "type": "paragraph",
      "content": "Mit großer Mehrheit beschlossen die Vereine die Einführung einer verpflichtenden Liveübertragung aller Spiele der 1. Bundesliga. Die Rugby Bundesliga setzt damit einen weiteren wichtigen Schritt in Richtung Professionalisierung und Sichtbarkeit."
    },
    {
      "type": "paragraph",
      "content": "Die Liveübertragungen sollen dazu beitragen, die Reichweite des deutschen Rugbys zu erhöhen, Fans einen besseren Zugang zu den Spielen zu ermöglichen und die Vermarktungsmöglichkeiten der Liga weiter auszubauen. Die Bundesliga entwickelt sich damit konsequent von der reinen Videoaufzeichnung hin zu einem modernen Streamingangebot."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Social Media als Gemeinschaftsprojekt"
    },
    {
      "type": "paragraph",
      "content": "Im Bereich Social Media verständigten sich Vereine und RBA auf eine gemeinsame Weiterentwicklung der digitalen Kommunikation. Die konkreten Ausgestaltungen werden in den kommenden Wochen gemeinsam zwischen den Vereinen und dem Rugby Bundesliga Ausschuss abgestimmt."
    },
    {
      "type": "paragraph",
      "content": "Ziel ist es, die Sichtbarkeit der Bundesliga weiter zu erhöhen und die vorhandenen Reichweiten der Vereine noch besser für die gemeinsame Außendarstellung zu nutzen."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Stärkung der Integrität des Spielbetriebs"
    },
    {
      "type": "paragraph",
      "content": "Mit deutlicher Mehrheit wurde beschlossen, zweite Mannschaften künftig nicht mehr für den Bundesligaspielbetrieb zuzulassen."
    },
    {
      "type": "paragraph",
      "content": "Die Entscheidung dient insbesondere der weiteren Stärkung der Integrität des Wettbewerbs. Die Vereine sprachen sich klar für einen Spielbetrieb aus, in dem alle Mannschaften unter vergleichbaren sportlichen Voraussetzungen antreten und keine kurzfristigen Kaderbewegungen zwischen erster und zweiter Mannschaft Einfluss auf die Wettbewerbsfähigkeit einzelner Teams nehmen können."
    },
    {
      "type": "paragraph",
      "content": "Gleichzeitig bleiben Spielgemeinschaften in der 2. Bundesliga unter klar definierten Voraussetzungen weiterhin möglich und bieten insbesondere kleineren Standorten Entwicklungsperspektiven."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Ein klares Bekenntnis zu Luxemburg und zur Gemeinschaft"
    },
    {
      "type": "paragraph",
      "content": "Besonders intensiv wurde die Diskussion um die Rolle ausländischer Mannschaften innerhalb der Bundesliga geführt. Der Antrag auf Ausschluss ausländischer Mannschaften aus der 1. Bundesliga fand keine Mehrheit."
    },
    {
      "type": "paragraph",
      "content": "Vielmehr setzte sich in den Diskussionen deutlich ein anderer Gedanke durch: Solidarität, Gemeinschaftsgefühl und gegenseitiger Respekt."
    },
    {
      "type": "paragraph",
      "content": "Der RC Luxemburg ist ein vollwertiges Mitglied von Rugby Deutschland und seit Jahren ein wertvoller Bestandteil des Bundesligaspielbetriebs. Die Vereine machten in ihren Wortbeiträgen deutlich, dass sportliche Entwicklung heute nicht an Landesgrenzen enden darf."
    },
    {
      "type": "paragraph",
      "content": "Mit dieser Entscheidung wurde ein klares Zeichen gesetzt. Für Gemeinschaft statt Ausgrenzung. Für den europäischen Gedanken im Rugby. Für sportliche Weiterentwicklung durch Zusammenarbeit über Grenzen hinweg."
    },
    {
      "type": "paragraph",
      "content": "Aus Sicht des Rugby Bundesliga Ausschusses ist die Diskussion darüber, ob und in welchem Umfang Luxemburg Teil der Bundesliga ist, damit beendet. Der RC Luxemburg gehört zur Rugby Bundesliga. Weitere Grundsatzdiskussionen hierzu sind weder erforderlich noch zielführend."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Pilotprojekt Platzierungsspiele in der 2. Bundesliga"
    },
    {
      "type": "paragraph",
      "content": "Einen besonders zukunftsweisenden Beschluss fassten die Vereine mit der Einführung eines Pilotprojekts für Platzierungsspiele in der 2. Bundesliga."
    },
    {
      "type": "paragraph",
      "content": "Nach Abschluss der regulären Saison werden künftig Mannschaften gleicher Tabellenplätze der Staffeln Nord/Ost und Süd/West gegeneinander antreten. Ziel ist es, den Wettbewerb für einen deutlich größeren Teil der Vereine attraktiv bis zum Saisonende zu gestalten."
    },
    {
      "type": "paragraph",
      "content": "Bisher endete die Saison für viele Mannschaften unmittelbar nach Abschluss der regulären Spielrunde, während lediglich die Aufstiegsanwärter weitere Pflichtspiele bestritten. Mit den neuen Platzierungsspielen erhalten nun auch die übrigen Vereine zusätzliche sportliche Ziele und attraktive Begegnungen."
    },
    {
      "type": "paragraph",
      "content": "Darüber hinaus bieten die Spiele erstmals einen direkten Leistungsvergleich zwischen den beiden Staffeln der 2. Bundesliga. Die Vereine erhalten wertvolle sportliche Erkenntnisse, Zuschauer dürfen sich auf neue Paarungen freuen und der bundesweite Charakter der Liga wird weiter gestärkt."
    },
    {
      "type": "paragraph",
      "content": "Nach Abschluss der Pilotphase erfolgt eine gemeinsame Auswertung, um über eine dauerhafte Etablierung des Formats zu entscheiden."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Auf und Abstieg: Klarheit für die Saison 2026/27"
    },
    {
      "type": "paragraph",
      "content": "Mit deutlicher Mehrheit beschlossen die Vereine zudem die Vorgehensweise für die kommende Saison hinsichtlich Auf und Abstieg."
    },
    {
      "type": "paragraph",
      "content": "Der RC Luxemburg verbleibt in der 1. Bundesliga. Damit wird für die Saison 2026/27 auf einen Abstieg aus der höchsten Spielklasse verzichtet."
    },
    {
      "type": "paragraph",
      "content": "Die Notwendigkeit eines Wildcardverfahrens für einen zusätzlichen Aufsteiger besteht nicht. Im Rahmen der Beratungen wurde deutlich, dass sich kein Verein außer dem RC Luxemburg für einen Aufstieg in die 1. Bundesliga ausgesprochen hat. Zudem ist nach Prüfung der eingereichten Lizenzunterlagen davon auszugehen, dass ein mögliches Wildcardverfahren zum identischen Ergebnis geführt hätte."
    },
    {
      "type": "paragraph",
      "content": "Durch diese Entscheidung entstehen jeweils freie Plätze in der 2. Bundesliga Nord/Ost sowie in der 2. Bundesliga Süd/West. Diese Plätze werden zum 1. Juli im Rahmen eines Wildcardverfahrens ausgeschrieben."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Weitere wichtige Beschlüsse"
    },
    {
      "type": "paragraph",
      "content": "Zusätzlich wurden die Vereinheitlichung von Fristen und Zeitangaben innerhalb der Ordnungen beschlossen, die Kautionsregelung durch eine transparentere Ordnungsgebühr ersetzt sowie die überarbeitete RBA Ordnung einschließlich der Möglichkeit von Online und Hybridsitzungen verabschiedet."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Ein Prozess, der Früchte trägt"
    },
    {
      "type": "paragraph",
      "content": "Die Sitzung in Hannover war ein weiterer Beleg dafür, dass die Rugby Bundesliga auf einem sehr guten Weg ist. Die Vereine diskutieren intensiv, vertreten ihre Positionen klar und arbeiten gleichzeitig konstruktiv an gemeinsamen Lösungen."
    },
    {
      "type": "paragraph",
      "content": "All diese Entwicklungen der letzten beiden Jahre fanden direkt im Anschluss ihren sportlichen Höhepunkt im Bundesliga Finale 2026. Dieses Finale war nicht nur ein herausragendes Rugbyereignis, sondern auch ein sichtbares Ergebnis der gemeinsamen Arbeit vieler Vereine, Ehrenamtlicher und Funktionsträger."
    },
    {
      "type": "paragraph",
      "content": "Entwicklung ist kein einzelner großer Sprung. Entwicklung ist die Summe vieler kleiner Schritte, die konsequent in dieselbe Richtung führen."
    },
    {
      "type": "paragraph",
      "content": "In diesem Sinne:"
    },
    {
      "type": "paragraph",
      "content": "Trust the Process.",
      "emphasis": "strong"
    },
    {
      "type": "paragraph",
      "content": "Keep on Rucking!",
      "emphasis": "strong"
    }
  ]
};
